import { Injectable } from '@angular/core';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as companyProfileQuery from './company-profile.selectors';
import * as actions from './company-profile.actions';

@Injectable()
export class CompanyProfileFacade {
  companyProfileSkeletonLoaded$ = this.store.pipe(
    select(companyProfileQuery.getCompanyProfileSkeletonLoaded)
  );
  companyProfileSkeletonLoading$ = this.store.pipe(
    select(companyProfileQuery.getCompanyProfileSkeletonLoading)
  );
  companyProfileAuditSkeleton$ = this.store.pipe(
    select(companyProfileQuery.getCompanyProfileAuditSkeleton)
  );

  companyProfileAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getCompanyProfileAuditLoaded)
  );
  companyProfileAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getCompanyProfileAuditLoading)
  );
  companyProfileAudits$ = this.store.pipe(select(companyProfileQuery.getCompanyProfileAudits));

  aircraftTypeRatingAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getAircraftTypeRatingAuditLoaded)
  );
  aircraftTypeRatingAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getAircraftTypeRatingAuditLoading)
  );
  aircraftTypeRatingAudits$ = this.store.pipe(
    select(companyProfileQuery.getAircraftTypeRatingAudits)
  );

  companyAddressAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getCompanyAddressAuditLoaded)
  );
  companyAddressAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getCompanyAddressAuditLoading)
  );
  companyAddressAudits$ = this.store.pipe(select(companyProfileQuery.getCompanyAddressAudits));

  customerDutyAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getCustomerDutyAuditLoaded)
  );
  customerDutyAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getCustomerDutyAuditLoading)
  );
  customerDutyAudits$ = this.store.pipe(select(companyProfileQuery.getCustomerDutyAudits));

  delayTypeAuditsLoaded$ = this.store.pipe(select(companyProfileQuery.getDelayTypeAuditLoaded));
  delayTypeAuditsLoading$ = this.store.pipe(select(companyProfileQuery.getDelayTypeAuditLoading));
  delayTypeAudits$ = this.store.pipe(select(companyProfileQuery.getDelayTypeAudits));

  departmentAuditsLoaded$ = this.store.pipe(select(companyProfileQuery.getDepartmentAuditLoaded));
  departmentAuditsLoading$ = this.store.pipe(select(companyProfileQuery.getDepartmentAuditLoading));
  departmentAudits$ = this.store.pipe(select(companyProfileQuery.getDepartmentAudits));

  dutyTimeBufferAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getDutyTimeBufferAuditLoaded)
  );
  dutyTimeBufferAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getDutyTimeBufferAuditLoading)
  );
  dutyTimeBufferAudits$ = this.store.pipe(select(companyProfileQuery.getDutyTimeBufferAudits));

  expenseTypeAuditsLoaded$ = this.store.pipe(select(companyProfileQuery.getExpenseTypeAuditLoaded));
  expenseTypeAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getExpenseTypeAuditLoading)
  );
  expenseTypeAudits$ = this.store.pipe(select(companyProfileQuery.getExpenseTypeAudits));

  crewMemberTypeAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getCrewMemberTypeAuditLoaded)
  );
  crewMemberTypeAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getCrewMemberTypeAuditLoading)
  );
  crewMemberTypeAudits$ = this.store.pipe(select(companyProfileQuery.getCrewMemberTypeAudits));

  paymentTypeAuditsLoaded$ = this.store.pipe(select(companyProfileQuery.getPaymentTypeAuditLoaded));
  paymentTypeAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getPaymentTypeAuditLoading)
  );
  paymentTypeAudits$ = this.store.pipe(select(companyProfileQuery.getPaymentTypeAudits));

  businessCategoryAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getBusinessCategoryAuditLoaded)
  );
  businessCategoryAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getBusinessCategoryAuditLoading)
  );
  businessCategoryAudits$ = this.store.pipe(select(companyProfileQuery.getBusinessCategoryAudits));

  jobGradeAuditsLoaded$ = this.store.pipe(select(companyProfileQuery.getJobGradeAuditLoaded));
  jobGradeAuditsLoading$ = this.store.pipe(select(companyProfileQuery.getJobGradeAuditLoading));
  jobGradeAudits$ = this.store.pipe(select(companyProfileQuery.getJobGradeAudits));

  staffEventTypeAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getStaffEventTypeAuditLoaded)
  );
  staffEventTypeAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getStaffEventTypeAuditLoading)
  );
  staffEventTypeAudits$ = this.store.pipe(select(companyProfileQuery.getStaffEventTypeAudits));

  staffGroupAuditsLoaded$ = this.store.pipe(select(companyProfileQuery.getStaffGroupAuditLoaded));
  staffGroupAuditsLoading$ = this.store.pipe(select(companyProfileQuery.getStaffGroupAuditLoading));
  staffGroupAudits$ = this.store.pipe(select(companyProfileQuery.getStaffGroupAudits));

  dutyTimeAllowanceAuditsLoaded$ = this.store.pipe(
    select(companyProfileQuery.getDutyTimeAllowanceAuditLoaded)
  );
  dutyTimeAllowanceAuditsLoading$ = this.store.pipe(
    select(companyProfileQuery.getDutyTimeAllowanceAuditLoading)
  );
  dutyTimeAllowanceAudits$ = this.store.pipe(
    select(companyProfileQuery.getDutyTimeAllowanceAudits)
  );

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadCompanyProfileAudit() {
    this.store.dispatch(actions.ResetCompanyProfile());
    this.store.dispatch(actions.LoadCompanyProfileAuditSkeleton());
  }

  loadCompanyProfileAudits(companyProfileId: number) {
    this.store.dispatch(
      actions.LoadCompanyProfileAudit({ companyProfileId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadAircraftTypeRatingAudits(aircraftTypeRatingId: number) {
    this.store.dispatch(
      actions.LoadAircraftTypeRatingAudit({
        aircraftTypeRatingId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadCompanyAddressAudits(companyAddressId: number) {
    this.store.dispatch(
      actions.LoadCompanyAddressAudit({ companyAddressId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadCustomerDutyAudits(customerDutyId: number) {
    this.store.dispatch(
      actions.LoadCustomerDutyAudit({ customerDutyId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadDelayTypeAudits(delayTypeId: number) {
    this.store.dispatch(
      actions.LoadDelayTypeAudit({ delayTypeId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadDepartmentAudits(departmentId: number) {
    this.store.dispatch(
      actions.LoadDepartmentAudit({ departmentId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadDutyTimeBufferAudits(dutyTimeBufferId: number) {
    this.store.dispatch(
      actions.LoadDutyTimeBufferAudit({ dutyTimeBufferId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadExpenseTypeAudits(expenseTypeId: number) {
    this.store.dispatch(
      actions.LoadExpenseTypeAudit({ expenseTypeId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadCrewMemberTypeAudits(crewMemberTypeId: number) {
    this.store.dispatch(
      actions.LoadCrewMemberTypeAudit({ crewMemberTypeId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadPaymentTypeAudits(paymentTypeId: number) {
    this.store.dispatch(
      actions.LoadPaymentTypeAudit({ paymentTypeId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadBusinessCategoryAudits(businessCategoryId: number) {
    this.store.dispatch(
      actions.LoadBusinessCategoryAudit({
        businessCategoryId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadJobGradeAudits(jobGradeId: number) {
    this.store.dispatch(
      actions.LoadJobGradeAudit({ jobGradeId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadStaffEventTypeAudits(staffEventTypeId: number) {
    this.store.dispatch(
      actions.LoadStaffEventTypeAudit({ staffEventTypeId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadStaffGroupAudits(staffGroupId: number) {
    this.store.dispatch(
      actions.LoadStaffGroupAudit({ staffGroupId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadDutyTimeAllowanceAudits(dutyTimeAllowanceId: number) {
    this.store.dispatch(
      actions.LoadDutyTimeAllowanceAudit({
        dutyTimeAllowanceId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  nextCompanyProfileAuditPage(companyProfileId: number) {
    this.store.dispatch(actions.LoadNextPageCompanyProfileAudit({ companyProfileId }));
  }

  nextAircraftTypeRatingAuditPage(aircraftTypeRatingId: number) {
    this.store.dispatch(actions.LoadNextPageAircraftTypeRatingAudit({ aircraftTypeRatingId }));
  }

  nextCompanyAddressAuditPage(companyAddressId: number) {
    this.store.dispatch(actions.LoadNextPageCompanyAddressAudit({ companyAddressId }));
  }

  nextCustomerDutyAuditPage(customerDutyId: number) {
    this.store.dispatch(actions.LoadNextPageCustomerDutyAudit({ customerDutyId }));
  }

  nextDepartmentAuditPage(departmentId: number) {
    this.store.dispatch(actions.LoadNextPageDepartmentAudit({ departmentId }));
  }

  nextDelayTypeAuditPage(delayTypeId: number) {
    this.store.dispatch(actions.LoadNextPageDelayTypeAudit({ delayTypeId }));
  }

  nextDutyTimeBufferAuditPage(dutyTimeBufferId: number) {
    this.store.dispatch(actions.LoadNextPageDutyTimeBufferAudit({ dutyTimeBufferId }));
  }

  nextExpenseTypeAuditPage(expenseTypeId: number) {
    this.store.dispatch(actions.LoadNextPageExpenseTypeAudit({ expenseTypeId }));
  }

  nextCrewMemberTypeAuditPage(crewMemberTypeId: number) {
    this.store.dispatch(actions.LoadNextPageCrewMemberTypeAudit({ crewMemberTypeId }));
  }

  nextPaymentTypeAuditPage(paymentTypeId: number) {
    this.store.dispatch(actions.LoadNextPagePaymentTypeAudit({ paymentTypeId }));
  }

  nextBusinessCategoryAuditPage(businessCategoryId: number) {
    this.store.dispatch(actions.LoadNextPageBusinessCategoryAudit({ businessCategoryId }));
  }

  nextJobGradeAuditPage(jobGradeId: number) {
    this.store.dispatch(actions.LoadNextPageJobGradeAudit({ jobGradeId }));
  }

  nextStaffEventTypeAuditPage(staffEventTypeId: number) {
    this.store.dispatch(actions.LoadNextPageStaffEventTypeAudit({ staffEventTypeId }));
  }

  nextStaffGroupAuditPage(staffGroupId: number) {
    this.store.dispatch(actions.LoadNextPageStaffGroupAudit({ staffGroupId }));
  }

  nextDutyTimeAllowanceAuditPage(dutyTimeAllowanceId: number) {
    this.store.dispatch(actions.LoadNextPageDutyTimeAllowanceAudit({ dutyTimeAllowanceId }));
  }
}
